export default __webpack_public_path__ + "static/media/avatar_alison6.0684d008.mp3";